module.exports = __webpack_public_path__ + "static/media/receive-report.248a1dd3.svg";